import {
  TableCell,
  TableRow,
  styled,
  tableCellClasses,
  Button,
  Typography,
  Grid,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: ".1em .5em",
  color: "#000 !important",
  color: "black",

  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "black !important",
    color: theme.palette.common.white,
    padding: "0 !important",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  padding: "0 !important",

  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
    padding: "0 !important",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export const StyledButton = styled(Button)(() => ({
  width: "140px",
  float: "right",
  marginTop: "4em",
  backgroundColor: "#06623B",
  color: "#fff",
  ":hover": { background: "#06623B" },
}));

export const StyledMatchGrid = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-around",
  minWidth: "230px",
}));

export const useStyles = makeStyles({
  loader: {
    width: "100%",
    height: "100vh",
    position: "fixed",
    zIndex: 999,
    top: "0",
    left: "0",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // backgroundColor: "red",
  },
  outlineInputBorder: {
    "& * > fieldset ": {
      display: "none !important",
    },
  },
  selectBox: {
    border: "1.47px solid #C4C4C4 !important",
    borderRadius: "8px",
    margin: "3px 0px",
    padding: "2px 5px",
    fontSize: "14px !important",
    fontWeight: "700 !important",
  },
  textBoxMain: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    backgroundColor: "#C4C4C4",
    borderRadius: "8px",
  },
  numberBox: {
    backgroundColor: "#fff",
    padding: "6px",
    width: 30,
    borderRadius: "8px 0px 0px 8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    border: "1px solid #C4C4C4",
  },
  outlineInput: {
    width: "28px",
    height: "28px",
    border: "1px solid #000000 !important",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "5px !important",

    "& * > input ": {
      textAlign: "center !important",
      fontSize: "12px !important",
    },
  },

  // Table

  textBox: {
    display: "flex",
    alignItems: "center",
    // backgroundColor: "#C4C4C4",
    borderRadius: "8px",
    width: "100%",
  },
  typoMain: {
    color: "#fff",
    height: "25px",
    width: "25px",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "0 !important",
  },
  redCircle: {
    backgroundColor: "#FF0000",
    borderRadius: "50%",
    // margin: "auto",
  },
  yellowCircle: {
    backgroundColor: "#FFC700",
    borderRadius: "50%",
    // margin: "auto",
  },
  textBoxChild: {
    width: "70%",
    color: "#fff",
    fontSize: "14px !important",
    fontWeight: "700 !important",
  },
});
